module.exports = __webpack_public_path__ + "img/Glyphter.42390aa5.svg";